(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wl-customer-experience"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-wl-care]');
    if (!root) return;
    const trigger = root.querySelector('.wl-care__trigger');
    const dialog = root.querySelector('dialog');
    const close = root.querySelector('[data-wl-care-close]');
    const visual = root.querySelector('.wl-care__visual');
    const image = root.querySelector('[data-wl-care-image]');
    const count = root.querySelector('[data-wl-care-count]');
    const eyebrow = root.querySelector('[data-wl-care-eyebrow]');
    const title = root.querySelector('[data-wl-care-feature-title]');
    const copy = root.querySelector('[data-wl-care-copy]');
    const action = root.querySelector('[data-wl-care-action]');
    const choices = [...root.querySelectorAll('[data-wl-care-choice]')];

    let revealTimer;
    const reveal = () => {
      root.classList.add('is-visible');
      window.removeEventListener('scroll', revealOnScroll);
      if (revealTimer) window.clearTimeout(revealTimer);
      try { window.sessionStorage.setItem('wlCareRevealed', 'true'); } catch (error) { /* Storage can be unavailable in privacy mode. */ }
    };
    const revealOnScroll = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable > 0 && window.scrollY / scrollable >= 0.3) reveal();
    };
    let wasRevealed = false;
    try { wasRevealed = window.sessionStorage.getItem('wlCareRevealed') === 'true'; } catch (error) { /* Fall back to timed reveal. */ }
    if (wasRevealed) reveal();
    else {
      revealTimer = window.setTimeout(reveal, 10000);
      window.addEventListener('scroll', revealOnScroll, { passive: true });
      revealOnScroll();
    }

    trigger.addEventListener('click', () => {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    choices.forEach(choice => choice.addEventListener('click', () => {
      choices.forEach(item => {
        const active = item === choice;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      visual.classList.add('is-changing');
      window.setTimeout(() => {
        image.src = choice.dataset.image;
        image.alt = choice.dataset.alt;
        count.textContent = choice.dataset.count;
        eyebrow.textContent = choice.dataset.eyebrow;
        title.textContent = choice.dataset.title;
        copy.textContent = choice.dataset.copy;
        action.href = choice.dataset.href;
        action.firstChild.textContent = `${choice.dataset.action} `;
        if (choice.dataset.external) {
          action.target = '_blank';
          action.rel = 'noopener';
        } else {
          action.removeAttribute('target');
          action.removeAttribute('rel');
        }
        visual.classList.remove('is-changing');
      }, 150);
    }));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wl-welcome-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-wl-welcome]');
    if (!root) return;
    const dialog = root.querySelector('[data-wl-welcome-dialog]');
    const close = root.querySelector('[data-wl-welcome-close]');
    const success = root.querySelector('[data-wl-welcome-success]');
    const errors = root.querySelector('[data-wl-welcome-errors]');
    const dismissedKey = 'wl_welcome_dismissed_at';
    const subscribedKey = 'wl_welcome_subscribed';
    const fourteenDays = 14 * 24 * 60 * 60 * 1000;
    let eligibleAt = Date.now() + 8000;
    let opened = false;

    const rememberDismissal = () => {
      try { localStorage.setItem(dismissedKey, String(Date.now())); } catch (_) {}
    };
    const isSuppressed = () => {
      try {
        if (localStorage.getItem(subscribedKey) === '1') return true;
        const dismissedAt = Number(localStorage.getItem(dismissedKey) || 0);
        return dismissedAt > 0 && Date.now() - dismissedAt < fourteenDays;
      } catch (_) { return false; }
    };
    const tryOpen = (force = false) => {
      if (opened || !dialog || typeof dialog.showModal !== 'function') return;
      if (!force && (Date.now() < eligibleAt || isSuppressed())) return;
      const another = document.querySelector('dialog[open]');
      if (another && another !== dialog) {
        window.setTimeout(() => tryOpen(force), 3500);
        return;
      }
      opened = true;
      dialog.showModal();
      const focusTarget = success || errors || dialog.querySelector('input');
      if (focusTarget) window.setTimeout(() => focusTarget.focus(), 80);
    };
    const dismiss = () => {
      rememberDismissal();
      if (dialog.open) dialog.close();
    };

    close.addEventListener('click', dismiss);
    dialog.addEventListener('cancel', rememberDismissal);
    dialog.addEventListener('click', event => {
      const box = dialog.getBoundingClientRect();
      const outside = event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
      if (outside) dismiss();
    });

    if (success) {
      try { localStorage.setItem(subscribedKey, '1'); } catch (_) {}
      tryOpen(true);
      return;
    }
    if (errors) {
      tryOpen(true);
      return;
    }
    if (isSuppressed()) return;

    window.setTimeout(tryOpen, 24000);
    window.addEventListener('scroll', () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max >= .5) tryOpen();
    }, { passive: true });
    document.addEventListener('mouseout', event => {
      if (event.clientY <= 0 && !event.relatedTarget) tryOpen();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
